export default "__VITE_ASSET__DtvZV6O5__"